export const state = () => ({
  sessionDetailsModal: null,
  sessionRatingModal: null,
  speakerDetailsModal: null,
});
export const mutations = {
  openSessionDetailsModal(state, exhibitorId) {
    state.sessionDetailsModal = exhibitorId;
  },
  openSessionRatingModal(state, exhibitorId) {
    state.sessionRatingModal = exhibitorId;
  },
  openSpeakerDetailsModal(state, exhibitorId) {
    state.speakerDetailsModal = exhibitorId;
  },
  closeSessionDetailsModal(state) {
    state.sessionDetailsModal = null;
  },
  closeSessionRatingModal(state) {
    state.sessionRatingModal = null;
  },
  closeSpeakerDetailsModal(state) {
    state.speakerDetailsModal = null;
  },
};
export const actions = {};
export const getters = {
  sessionDetailsModalVisible(state) {
    return !!state.sessionDetailsModal;
  },
  sessionRatingModalVisible(state) {
    return !!state.sessionRatingModal;
  },
  speakerDetailsModalVisible(state) {
    return !!state.speakerDetailsModal;
  },
  sessionDetailsModalProps(state) {
    return {
      agendaSessionId: state.sessionDetailsModal,
    };
  },

  sessionRatingModalProps(state, getters, rootState, rootGetters) {
    return {
      ratings: rootGetters["agendas/activeAgendaRatings"],
      agendaSessionId: state.sessionRatingModal,
      componentId: state.componentId,
    };
  },

  speakerDetailsModalProps(state, getters, rootState, rootGetters) {
    return {
      speaker: state.speakerDetailsModal,
      eventId: rootState.eventId,
    };
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
